module.exports = __webpack_public_path__ + "index.png?48f95cc9c0fc345ee24c1007288baae7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index.png
// module id = 270
// module chunks = 0 1